import { render } from "./OrdenCapituloEnUnidad.vue?vue&type=template&id=54fb30ef&scoped=true"
import script from "./OrdenCapituloEnUnidad.vue?vue&type=script&lang=js"
export * from "./OrdenCapituloEnUnidad.vue?vue&type=script&lang=js"

import "./OrdenCapituloEnUnidad.vue?vue&type=style&index=0&id=54fb30ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fb30ef"]])

export default __exports__